import ApiService from "../service/ApiService";
import ApiServiceAxios from "../service/ApiServiceAxios";
import MethodService from "../service/MethodService";

let moduleApi = {};
let moduleName = "ho_so_831";
let hostApi831 = window.MyConfig.hostApi831;
let hostApi831PHR = window.MyConfig.hostApi831PHR;
let hostApDkk = window.MyConfig.hostApDkk;
let cosUrl = window.MyConfig.cosUrl;
let applicationCode831 = window.MyConfig.applicationCode831;
let token = MethodService.getToken();
let UrlApiPacs = window.MyConfig.UrlApiPacs;
let UrlApiEHIS = window.MyConfig.UrlApiEHIS;
let UrlApiPHIS = window.MyConfig.UrlApiPHIS;

moduleApi.chiTiet = data => {
  let api = {
    method: "POST",
    url: hostApi831 + "GetHoSo831ByBoHanhChanh",
    data: data,
    params: {
      token: token,
      ApplicationCode: applicationCode831,
    },
    message: {
      success: "",
      error: "Chưa có thông tin hồ sơ sức khỏe cá nhân"
    }
  };

  return ApiServiceAxios(api);
};

moduleApi.chiTietEHR = data => {
  let api = {
    method: "POST",
    url: hostApi831 + "GetHSSK_CNByBoHanhChanh",
    data: data,
    params: {
      token: token,
      ApplicationCode: applicationCode831,
    },
    message: {
      success: "",
      error: "Chưa có thông tin hồ sơ sức khỏe cá nhân"
    }
  };

  return ApiServiceAxios(api);
};

moduleApi.chiTietPHR = data => {
  let api = {
    method: "POST",
    url: hostApi831 + "GetPHRByBoHanhChanh",
    data: data,
    params: {
      token: token,
      ApplicationCode: applicationCode831,
    },
    message: {
      success: "",
      error: "Chưa có thông tin hồ sơ sức khỏe cá nhân"
    }
  };

  return ApiServiceAxios(api);
};

moduleApi.getYeuToSucKhoe = () => {
  let api = {
    module: "nguoi_dan",
    type: "get_index_831",
    params: {
      c: "ytsk"
    }
  };
  return ApiService(api);
};
moduleApi.getDiUng = () => {
  let api = {
    module: "nguoi_dan",
    type: "get_index_831",
    params: {
      c: "diung"
    }
  };
  return ApiService(api);
};
moduleApi.getBenhTat = () => {
  let api = {
    module: "nguoi_dan",
    type: "get_index_831",
    params: {
      c: "benhtat"
    }
  };
  return ApiService(api);
};
moduleApi.getKhuyetTat = () => {
  let api = {
    module: "nguoi_dan",
    type: "get_index_831",
    params: {
      c: "khuyettat"
    }
  };
  return ApiService(api);
};
moduleApi.getVacxin = () => {
  let api = {
    module: "nguoi_dan",
    type: "get_index_831",
    params: {
      c: "vacxin"
    }
  };
  return ApiService(api);
};

moduleApi.getHSSKCN = MaDangKyOrMaThe => {
  let api = {
    method: "GET",
    url: hostApi831 + "GetHSSK_CN",
    // data: {},
    params: {
      token: token,
      MaDangKyOrMaThe: MaDangKyOrMaThe,
      ApplicationCode: applicationCode831
    },
    message: {
      success: "",
      error: "Chưa có thông tin hồ sơ sức khỏe cá nhân"
    }
  };

  return ApiServiceAxios(api);
};

moduleApi.updateHSSKCN = dataForm => {
  let api = {
    method: "POST",
    url: hostApi831PHR + "SaveHSSK_CN_BANTHAN",
    data: dataForm,
    params: {
      token: token,
      ApplicationCode: applicationCode831
    },
    message: {
      success: "",
      error: "Cập nhật không thành công"
    }
  };

  return ApiServiceAxios(api);
};

moduleApi.updateHSSKCNGD = dataForm => {
  let api = {
    method: "POST",
    url: hostApi831PHR + "SaveHSSK_CN_GIADINH",
    data: dataForm,
    params: {
      token: token,
      ApplicationCode: applicationCode831
    },
    message: {
      success: "",
      error: "Cập nhật không thành công"
    }
  };

  return ApiServiceAxios(api);
};

moduleApi.updateHSSKCNDC = dataForm => {
  let api = {
    method: "POST",
    url: hostApi831PHR + "SaveHSSK_CN_DIACHI",
    data: dataForm,
    params: {
      token: token,
      ApplicationCode: applicationCode831
    },
    message: {
      success: "",
      error: "Cập nhật không thành công"
    }
  };

  return ApiServiceAxios(api);
};

moduleApi.updateBHYT = dataForm => {
  let api = {
    method: "POST",
    url: hostApi831 + "SaveHSSK_BHYT",
    data: dataForm,
    params: {
      token: token,
      ApplicationCode: applicationCode831
    },
    message: {
      success: "",
      error: "Cập nhật không thành công"
    }
  };

  return ApiServiceAxios(api);
};

//api save 831
moduleApi.SaveHSSK_TT_LUC_SINH = dataForm => {
  let api = {
    method: "POST",
    type: "partialUpdate",
    url: hostApi831 + "SaveHSSK_TT_LUC_SINH",
    data: dataForm,
    params: {
      token: token,
      ApplicationCode: applicationCode831
    },
    message: {
      success: "hidden",
      error: "Cập nhật không thành công"
    }
  };

  return ApiServiceAxios(api);
};

moduleApi.SaveHSSK_YTSK = dataForm => {
  let api = {
    method: "POST",
    type: "partialUpdate",
    url: hostApi831 + "SaveHSSK_YTSK",
    data: dataForm,
    // data: [{
    //   HSSK_Id: "id",
    //   YTSK_Id: "id",
    //   MOTA: "string",
    //   TAN_SUAT: "string",
    //   DA_BO: "boolean"
    // }],
    params: {
      token: token,
      ApplicationCode: applicationCode831
    },
    message: {
      success: "hidden",
      error: "Cập nhật không thành công"
    }
  };
  return ApiServiceAxios(api);
};

moduleApi.SaveHSSK_KTAT = dataForm => {
  let api = {
    method: "POST",
    type: "partialUpdate",
    url: hostApi831 + "SaveHSSK_KTAT",
    data: dataForm,
    // data: [{
    //   HSSK_Id: "id",
    //   KTAT_Id: "id",
    //   MOTA: "string",
    // }],
    params: {
      token: token,
      ApplicationCode: applicationCode831
    },
    message: {
      success: "hidden",
      error: "Cập nhật không thành công"
    }
  };
  return ApiServiceAxios(api);
};

moduleApi.SaveHSSK_PTHUAT = dataForm => {
  let api = {
    method: "POST",
    type: "partialUpdate",
    url: hostApi831 + "SaveHSSK_PTHUAT",
    data: dataForm,
    // data: [{
    //   HSSK_Id: "id",
    //   PTHUAT_Id: "id",
    //   MOTA: "string",
    // }],
    params: {
      token: token,
      ApplicationCode: applicationCode831
    },
    message: {
      success: "hidden",
      error: "Cập nhật không thành công"
    }
  };
  return ApiServiceAxios(api);
};

moduleApi.SaveHSSK_SKSS = dataForm => {
  let api = {
    method: "POST",
    type: "partialUpdate",
    url: hostApi831 + "SaveHSSK_SKSS",
    data: dataForm,
    // data: {
    // HSSK_Id: "id",
    // BP_TRANH_THAI: "string",
    // KY_THAI_CUOI: "string",
    // SL_CO_THAI: "string",
    // SL_SAY_THAI: "string",
    // SL_PHA_THAI: "string",
    // SL_DE: "string",
    // SL_DE_THUONG: "string",
    // SL_DE_KHO: "string",
    // SL_DE_MO: "string",
    // SL_DE_DTHANG: "string",
    // SL_DE_NON: "string",
    // SO_CON: "string",
    // BENH_PSAN: "string",
    // },
    params: {
      token: token,
      ApplicationCode: applicationCode831
    },
    message: {
      success: "hidden",
      error: "Cập nhật không thành công"
    }
  };
  return ApiServiceAxios(api);
};

moduleApi.SaveHSSK_VANDE_KHAC = dataForm => {
  let api = {
    method: "POST",
    type: "partialUpdate",
    url: hostApi831 + "SaveHSSK_VANDE_KHAC",
    data: dataForm,
    // data: {
    //   HSSK_Id: "id",
    //   HSSK_VANDE_KHAC_Id: "id",
    //   VAN_DE: "string"
    // }
    params: {
      token: token,
      ApplicationCode: applicationCode831
    },
    message: {
      success: "hidden",
      error: "Cập nhật không thành công"
    }
  };
  return ApiServiceAxios(api);
};

moduleApi.SaveHSSK_DIUNG = dataForm => {
  let api = {
    method: "POST",
    type: "partialUpdate",
    url: hostApi831 + "SaveHSSK_DIUNG",
    data: dataForm,
    // data: {
    //   HSSK_Id: "id",
    //   DIUNG_Id: "id",
    //   MOTA: "string"
    // }
    params: {
      token: token,
      ApplicationCode: applicationCode831
    },
    message: {
      success: "hidden",
      error: "Cập nhật không thành công"
    }
  };
  return ApiServiceAxios(api);
};

moduleApi.SaveHSSK_DIUNG_GD = dataForm => {
  let api = {
    method: "POST",
    type: "partialUpdate",
    url: hostApi831 + "SaveHSSK_DIUNG_GD",
    data: dataForm,
    // data: {
    //   HSSK_Id: "id",
    //   LBENH_CN_Id: "id",
    //   MOTA: "string",
    //   NGUOI_MAC: "string",
    // }
    params: {
      token: token,
      ApplicationCode: applicationCode831
    },
    message: {
      success: "hidden",
      error: "Cập nhật không thành công"
    }
  };
  return ApiServiceAxios(api);
};

moduleApi.SaveHSSK_BENHTAT = dataForm => {
  let api = {
    method: "POST",
    type: "partialUpdate",
    url: hostApi831 + "SaveHSSK_BENHTAT",
    data: dataForm,
    // data: {
    //   HSSK_Id: "id",
    //   LBENH_CN_Id: "id",
    //   MOTA: "string",
    //   MAC_BENH: "boolean",
    // }
    params: {
      token: token,
      ApplicationCode: applicationCode831
    },
    message: {
      success: "hidden",
      error: "Cập nhật không thành công"
    }
  };
  return ApiServiceAxios(api);
};

moduleApi.SaveHSSK_BENHTATGD = dataForm => {
  let api = {
    method: "POST",
    type: "partialUpdate",
    url: hostApi831 + "SaveHSSK_BENHTATGD",
    data: dataForm,
    // data: {
    //   HSSK_Id: "id",
    //   LBENH_CN_Id: "id",
    //   MOTA: "string",
    //   MAC_BENH: "boolean",
    //   NGUOI_MAC: "string",
    // }
    params: {
      token: token,
      ApplicationCode: applicationCode831
    },
    message: {
      success: "hidden",
      error: "Cập nhật không thành công"
    }
  };
  return ApiServiceAxios(api);
};

moduleApi.SaveHSSK_TCHUNG_UVAN = dataForm => {
  let api = {
    method: "POST",
    type: "partialUpdate",
    url: hostApi831 + "SaveHSSK_TCHUNG_UVAN",
    data: dataForm,
    params: {
      token: token,
      ApplicationCode: applicationCode831
    },
    message: {
      success: "hidden",
      error: "Cập nhật không thành công"
    }
  };
  return ApiServiceAxios(api);
};

moduleApi.getPTTT = id => {
  let api = {
    method: "GET",
    url: hostApi831 + "GetPTTTByIDDotKhamChuaBenh",
    params: {
      token: token,
      ApplicationCode: applicationCode831,
      IDDotKhamChuaBenh: id
    },
    message: {
      success: "hidden",
      error: "Lỗi tải dữ liệu!"
    }
  };
  return ApiServiceAxios(api);
};

/* oduleApi.getYeuToSucKhoe = () => {
  return {
    result: [
      {
        id: "1",
        code: "HutThuoc",
        name: "Hút thuốc"
      },
      {
        id: "2",
        code: "RuouBia",
        name: "Rượu bia"
      },
      {
        id: "3",
        code: "MaTuy",
        name: "Ma túy"
      },
      {
        id: "4",
        code: "HoatDongTheLuc",
        name: "Hoạt động thể lực"
      },
      {
        id: "5",
        code: "YeuToTiepXuc",
        name: "Yếu tố tiếp xúc"
      },
      {
        id: "6",
        code: "LoaiHoXi",
        name: "Loại hố xí"
      },
      {
        id: "99",
        code: "NguyCoKhac",
        name: "Nguy cơ khác"
      },
    ]
  };
};
 
moduleApi.getDiUng = () => {
  return {
    result: [
      {
        id: "1",
        code: "ThuocLa",
        name: "Thuốc lá"
      },
      {
        id: "2",
        code: "HoaChatMyPham",
        name: "Hóa chất mỹ phẩm"
      },
      {
        id: "3",
        code: "ThucPham ",
        name: "Thực phẩm"
      },
      {
        id: "99",
        code: "Khac",
        name: "Khác"
      },
    ]
  };
};
 
moduleApi.getBenhTat = () => {
  return {
    result: [
      {
        id: "1",
        code: "TimMach",
        name: "Tim mạch"
      },
      {
        id: "2",
        code: "TangHuyetAp",
        name: "Tăng huyết áp"
      },
      {
        id: "3",
        code: "DaiDuong",
        name: "Đái đường"
      },
      {
        id: "4",
        code: "DaDay",
        name: "Dạ dày"
      },
      {
        id: "5",
        code: "Phoi",
        name: "Phổi"
      },
      {
        id: "6",
        code: "HenSuyen",
        name: "Hen suyễn"
      },
      {
        id: "7",
        code: "BuouCo",
        name: "Bướu cổ"
      },
      {
        id: "8",
        code: "Gan",
        name: "Gan"
      },
      {
        id: "9",
        code: "TimBamSinh",
        name: "Tim bẩm sinh"
      },
      {
        id: "10",
        code: "TamThan",
        name: "Tâm thần"
      },
      {
        id: "11",
        code: "TuKy",
        name: "Tự kỷ"
      },
      {
        id: "12",
        code: "DongKinh",
        name: "Động kinh"
      },
      {
        id: "13",
        code: "UngThu",
        name: "Ung thư"
      },
      {
        id: "14",
        code: "Lao",
        name: "Lao"
      },
      {
        id: "99",
        code: "NguyCoKhac",
        name: "Nguy cơ khác"
      },
    ]
  };
};
 
moduleApi.getKhuyetTat = () => {
  return {
    result: [
      {
        id: "1",
        code: "ThinhGiac ",
        name: "Thính giác"
      },
      {
        id: "2",
        code: "ThiLuc",
        name: "Thi lực"
      },
      {
        id: "3",
        code: "Tay",
        name: "Tay"
      },
      {
        id: "4",
        code: "Chan",
        name: "Chân"
      },
      {
        id: "5",
        code: "CotSong",
        name: "Cột sống"
      },
      {
        id: "6",
        code: "MoiVomMien",
        name: "Khe hở môi, vòm miệng"
      },
      {
        id: "99",
        code: "Khac",
        name: "Khác"
      },
    ]
  };
};
 
moduleApi.getVacxin = () => {
  return {
    result: [
      {
        id: "1",
        code: "BCG",
        name: "BCG"
      },
      {
        id: "2",
        code: "VGBSoSinh",
        name: "VGB sơ sinh"
      },
      {
        id: "3",
        code: "DPT_VGB_Hib",
        name: "DPT - VGB-Hib"
      },
      {
        id: "4",
        code: "BaiLiet",
        name: "Bại liệt"
      },
      {
        id: "5",
        code: "Soi",
        name: "Sởi"
      },
      {
        id: "6",
        code: "DPT4",
        name: "DPT4"
      },
      {
        id: "7",
        code: "VNNBB",
        name: "VNNBB"
      },
      {
        id: "101",
        code: "Ta",
        name: "Tả"
      },
      {
        id: "102",
        code: "QuaiBi",
        name: "Quai bị"
      },
      {
        id: "103",
        code: "Cum",
        name: "Cúm"
      },
      {
        id: "104",
        code: "ThuongHan",
        name: "Thương Hàn"
      },
      {
        id: "105",
        code: "HPV",
        name: "HPV"
      },
      {
        id: "106",
        code: "PheCauKhuan",
        name: "Phế cầu khuẩn"
      },
      {
        id: "201",
        code: "UV",
        name: "Uốn ván"
      }
    ]
  };
};
 */

moduleApi.LoadDMQuocGia = () => {
  let api = {
    method: "GET",
    url: hostApi831 + "LoadDMQuocGia",
    // data: {},
    params: {
      token: MethodService.checkTokenTichHop(token),
      ApplicationCode: applicationCode831
    },
    message: {
      success: "",
      error: "Tải dữ liệu danh mục không thành công"
    }
  };

  return ApiServiceAxios(api);
};

moduleApi.LoadDMDanToc = () => {
  let api = {
    method: "GET",
    url: hostApi831 + "LoadDMDanToc",
    // data: {},
    params: {
      token: MethodService.checkTokenTichHop(token),
      ApplicationCode: applicationCode831
    },
    message: {
      success: "",
      error: "Tải dữ liệu danh mục không thành công"
    }
  };

  return ApiServiceAxios(api);
};

moduleApi.LoadDMGioiTinh = () => {
  let api = {
    method: "GET",
    url: hostApi831 + "LoadDMGioiTinh",
    // data: {},
    params: {
      token: MethodService.checkTokenTichHop(token),
      ApplicationCode: applicationCode831
    },
    message: {
      success: "",
      error: "Tải dữ liệu danh mục không thành công"
    }
  };

  return ApiServiceAxios(api);
};

moduleApi.LoadDMCSKCB = () => {
  let api = {
    method: "GET",
    url: hostApi831 + "LoadDMCSKCB",
    // data: {},
    params: {
      token: MethodService.checkTokenTichHop(token),
      ApplicationCode: applicationCode831
    },
    message: {
      success: "",
      error: "Tải dữ liệu danh mục không thành công"
    }
  };
  return ApiServiceAxios(api);
};

moduleApi.LoadDMTonGiao = () => {
  let api = {
    method: "GET",
    url: hostApi831 + "LoadDMTonGiao",
    // data: {},
    params: {
      token: MethodService.checkTokenTichHop(token),
      ApplicationCode: applicationCode831
    },
    message: {
      success: "",
      error: "Tải dữ liệu danh mục không thành công"
    }
  };
  return ApiServiceAxios(api);
};

moduleApi.LoadDMKhuyetTat = () => {
  let api = {
    method: "GET",
    url: hostApi831 + "LoadDMKhuyetTat",
    // data: {},
    params: {
      token: MethodService.checkTokenTichHop(token),
      ApplicationCode: applicationCode831
    },
    message: {
      success: "",
      error: "Tải dữ liệu danh mục không thành công"
    }
  };
  return ApiServiceAxios(api);
};

moduleApi.LoadDMKhoa = () => {
  let api = {
    method: "GET",
    url: hostApi831 + "LoadDMKhoa",
    // data: {},
    params: {
      token: MethodService.checkTokenTichHop(token),
      ApplicationCode: applicationCode831
    },
    message: {
      success: "",
      error: "Tải dữ liệu danh mục không thành công"
    }
  };
  return ApiServiceAxios(api);
};

moduleApi.LoadDMTinhThanh = () => {
  let api = {
    method: "GET",
    url: hostApi831 + "LoadDMTinhThanh",
    // data: {},
    params: {
      token: MethodService.checkTokenTichHop(token),
      ApplicationCode: applicationCode831
    },
    message: {
      success: "",
      error: "Tải dữ liệu danh mục không thành công"
    }
  };
  return ApiServiceAxios(api);
};

moduleApi.LoadDMQuanHuyen = MaTinhThanh => {
  let api = {
    method: "GET",
    url: hostApi831 + "LoadDMQuanHuyen",
    // data: {},
    params: {
      token: MethodService.checkTokenTichHop(token),
      ApplicationCode: applicationCode831
    },
    message: {
      success: "",
      error: "Tải dữ liệu danh mục không thành công"
    }
  };
  if (MaTinhThanh) {
    api.params.MaTinhThanh = MaTinhThanh;
  }
  return ApiServiceAxios(api);
};

moduleApi.LoadDMPhuongXa = (MaTinhThanh, MaQuanHuyen) => {
  let api = {
    method: "GET",
    url: hostApi831 + "LoadDMPhuongXa",
    // data: {},
    params: {
      token: MethodService.checkTokenTichHop(token),
      ApplicationCode: applicationCode831
    },
    message: {
      success: "",
      error: "Tải dữ liệu danh mục không thành công"
    }
  };
  if (MaTinhThanh) {
    api.params.MaTinhThanh = MaTinhThanh;
  }
  if (MaQuanHuyen) {
    api.params.MaQuanHuyen = MaQuanHuyen;
  }
  return ApiServiceAxios(api);
};

moduleApi.getAllInForNguoiDan = cardCode => {
  let api = {
    module: "nguoi_dan",
    type: "getAllInFor",
    params: {
      cardCode: cardCode
    }
  };
  return ApiService(api);
};

moduleApi.findByIdNguoiDan = id => {
  let api = {
    module: "nguoi_dan",
    type: "findById",
    params: {
      id: id
    }
  };
  return ApiService(api);
};

moduleApi.listNguoiDan = dataFilter => {
  let api = {
    module: "nguoi_dan",
    type: "list",
    value: dataFilter
  };
  return ApiService(api);
};

moduleApi.getPacs = cardCode => {
  let api = {
    method: "GET",
    url: UrlApiPacs + "GetDSCacLanChup",
    // data: {},
    params: {
      token: MethodService.checkTokenTichHop(token),
      ApplicationCode: applicationCode831,
      MasterPatientID: cardCode
    },
    message: {
      success: "",
      error: "Tải dữ liệu danh mục không thành công"
    }
  };
  return ApiServiceAxios(api);
};

moduleApi.getPHIS_HSSKCN = (body, tinh) => {
  let api = {
    method: "POST",
    url: UrlApiPHIS + "GetLSHSSK_CNAsync",
    data: body,
    params: {
      token: MethodService.checkTokenTichHop(token),
      ApplicationCode: applicationCode831,
      MaTinhThanhSoYTe: tinh
    },
    message: {
      success: "",
      error: "Tải dữ liệu danh mục không thành công"
    }
  };
  return ApiServiceAxios(api);
};

moduleApi.getPHIS_HSSKCNBT = (body, tinh) => {
  let api = {
    method: "POST",
    url: UrlApiPHIS + "GetFullLSHanhChanhBanThanAsync",
    data: body,
    params: {
      token: MethodService.checkTokenTichHop(token),
      ApplicationCode: applicationCode831,
      MaTinhThanhSoYTe: tinh
    },
    message: {
      success: "",
      error: "Tải dữ liệu danh mục không thành công"
    }
  };
  return ApiServiceAxios(api);
};

moduleApi.getPHIS_HSSKCNGD = (body, tinh) => {
  let api = {
    method: "POST",
    url: UrlApiPHIS + "GetFullLSHanhChanhGiaDinhAsync",
    data: body,
    params: {
      token: MethodService.checkTokenTichHop(token),
      ApplicationCode: applicationCode831,
      MaTinhThanhSoYTe: tinh
    },
    message: {
      success: "",
      error: "Tải dữ liệu danh mục không thành công"
    }
  };
  return ApiServiceAxios(api);
};

moduleApi.getPHIS_HSSKCNDC = (body, tinh) => {
  let api = {
    method: "POST",
    url: UrlApiPHIS + "GetFullLSHanhChanhDiaChiHK_KSAsync",
    data: body,
    params: {
      token: MethodService.checkTokenTichHop(token),
      ApplicationCode: applicationCode831,
      MaTinhThanhSoYTe: tinh
    },
    message: {
      success: "",
      error: "Tải dữ liệu danh mục không thành công"
    }
  };
  return ApiServiceAxios(api);
};

moduleApi.getPHIS_HSSK_TT_LUCSINH = (body, tinh) => {
  let api = {
    method: "POST",
    url: UrlApiPHIS + "GetFullLSTinhTrangLucSinhAsync",
    data: body,
    params: {
      token: MethodService.checkTokenTichHop(token),
      ApplicationCode: applicationCode831,
      MaTinhThanhSoYTe: tinh
    },
    message: {
      success: "",
      error: "Tải dữ liệu danh mục không thành công"
    }
  };
  return ApiServiceAxios(api);
};

moduleApi.getPHIS_HSSK_YTSK = (body, tinh) => {
  let api = {
    method: "POST",
    url: UrlApiPHIS + "GetFullLSYeuToSucKhoeAsync",
    data: body,
    params: {
      token: MethodService.checkTokenTichHop(token),
      ApplicationCode: applicationCode831,
      MaTinhThanhSoYTe: tinh
    },
    message: {
      success: "",
      error: "Tải dữ liệu danh mục không thành công"
    }
  };
  return ApiServiceAxios(api);
};

moduleApi.getPHIS_HSSK_DIUNG = (body, tinh) => {
  let api = {
    method: "POST",
    url: UrlApiPHIS + "GetFullLSDiUngCaNhanAsync",
    data: body,
    params: {
      token: MethodService.checkTokenTichHop(token),
      ApplicationCode: applicationCode831,
      MaTinhThanhSoYTe: tinh
    },
    message: {
      success: "",
      error: "Tải dữ liệu danh mục không thành công"
    }
  };
  return ApiServiceAxios(api);
};

moduleApi.getPHIS_HSSK_BENHTAT = (body, tinh) => {
  let api = {
    method: "POST",
    url: UrlApiPHIS + "GetFullLSBenhTatCaNhanAsync",
    data: body,
    params: {
      token: MethodService.checkTokenTichHop(token),
      ApplicationCode: applicationCode831,
      MaTinhThanhSoYTe: tinh
    },
    message: {
      success: "",
      error: "Tải dữ liệu danh mục không thành công"
    }
  };
  return ApiServiceAxios(api);
};

moduleApi.getPHIS_HSSK_KTAT = (body, tinh) => {
  let api = {
    method: "POST",
    url: UrlApiPHIS + "GetFullLSKhuyetTatAsync",
    data: body,
    params: {
      token: MethodService.checkTokenTichHop(token),
      ApplicationCode: applicationCode831,
      MaTinhThanhSoYTe: tinh
    },
    message: {
      success: "",
      error: "Tải dữ liệu danh mục không thành công"
    }
  };
  return ApiServiceAxios(api);
};

moduleApi.getPHIS_HSSK_PTHUAT = (body, tinh) => {
  let api = {
    method: "POST",
    url: UrlApiPHIS + "GetFullLSPhauThuatAsync",
    data: body,
    params: {
      token: MethodService.checkTokenTichHop(token),
      ApplicationCode: applicationCode831,
      MaTinhThanhSoYTe: tinh
    },
    message: {
      success: "",
      error: "Tải dữ liệu danh mục không thành công"
    }
  };
  return ApiServiceAxios(api);
};

moduleApi.getPHIS_HSSK_DIUNG_GD = (body, tinh) => {
  let api = {
    method: "POST",
    url: UrlApiPHIS + "GetFullLSDiUngGiaDinhAsync",
    data: body,
    params: {
      token: MethodService.checkTokenTichHop(token),
      ApplicationCode: applicationCode831,
      MaTinhThanhSoYTe: tinh
    },
    message: {
      success: "",
      error: "Tải dữ liệu danh mục không thành công"
    }
  };
  return ApiServiceAxios(api);
};

moduleApi.getPHIS_HSSK_BENHTAT_GD = (body, tinh) => {
  let api = {
    method: "POST",
    url: UrlApiPHIS + "GetFullLSBenhTatGiaDinhAsync",
    data: body,
    params: {
      token: MethodService.checkTokenTichHop(token),
      ApplicationCode: applicationCode831,
      MaTinhThanhSoYTe: tinh
    },
    message: {
      success: "",
      error: "Tải dữ liệu danh mục không thành công"
    }
  };
  return ApiServiceAxios(api);
};

moduleApi.getPHIS_HSSK_SKSS = (body, tinh) => {
  let api = {
    method: "POST",
    url: UrlApiPHIS + "GetFullLSSKSSAsync",
    data: body,
    params: {
      token: MethodService.checkTokenTichHop(token),
      ApplicationCode: applicationCode831,
      MaTinhThanhSoYTe: tinh
    },
    message: {
      success: "",
      error: "Tải dữ liệu danh mục không thành công"
    }
  };
  return ApiServiceAxios(api);
};

moduleApi.getPHIS_HSSK_VANDE_KHAC = (body, tinh) => {
  let api = {
    method: "POST",
    url: UrlApiPHIS + "GetFullLSVanDeKhacAsync",
    data: body,
    params: {
      token: MethodService.checkTokenTichHop(token),
      ApplicationCode: applicationCode831,
      MaTinhThanhSoYTe: tinh
    },
    message: {
      success: "",
      error: "Tải dữ liệu danh mục không thành công"
    }
  };
  return ApiServiceAxios(api);
};

moduleApi.getPHIS_HSSK_TIEM_CHUNG = cardCode => {
  let api = {
    method: "GET",
    url: UrlApiPHIS + "GetHSSK_TIEM_CHUNG",
    // data: {},
    params: {
      token: MethodService.checkTokenTichHop(token),
      ApplicationCode: applicationCode831,
      MaTinhThanhSoYTe: "",
      MaDangKyOrMaThe: cardCode
    },
    message: {
      success: "",
      error: "Tải dữ liệu danh mục không thành công"
    }
  };
  return ApiServiceAxios(api);
};

moduleApi.getPHIS_HSSK_TCHUNG_UVAN = cardCode => {
  let api = {
    method: "GET",
    url: UrlApiPHIS + "GetHSSK_TCHUNG_UVAN",
    // data: {},
    params: {
      token: MethodService.checkTokenTichHop(token),
      ApplicationCode: applicationCode831,
      MaTinhThanhSoYTe: "",
      MaDangKyOrMaThe: cardCode
    },
    message: {
      success: "",
      error: "Tải dữ liệu danh mục không thành công"
    }
  };
  return ApiServiceAxios(api);
};

moduleApi.requestOtp = cardCode => {
  let api = {
    module: moduleName,
    type: "requestOtp", //function mushroom
    value: {
      cardCode: cardCode
    }
  };
  return ApiService(api);
};

moduleApi.validateOtp = (cardCode, otp) => {
  let api = {
    module: moduleName,
    type: "validateOtp",
    value: {
      cardCode: cardCode,
      otp: otp
    }
  };
  return ApiService(api);
};

moduleApi.updateSdo = async dataDKKCheckCard => {
  try {
    const response = await fetch(cosUrl + "CosBhyt/UpdateSdo", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ApplicationCode: "THE",
        TokenCode: token
        // TokenCode:
        //   "fa28f4c1e647efaf86f8f4277125f3213b24599b47b4f2c7d2cb8bd64a93ea1f56511199e6d56eb88bf8ac49f7a6e83b6485e02185650c8f3bbcb0b9a237e3fa"
      },
      body: JSON.stringify(dataDKKCheckCard)
    });
    const data = await response.json();
    console.log("Success", data);
    return data;
  } catch (e) {
    console.log("Error", e);
    return false;
  }
};

moduleApi.dKKCheckCard = async dataDKKCheckCard => {
  console.log(hostApDkk + "DkkRegister/CheckHeinCard");
  console.log("token", token);
  try {
    const response = await fetch(hostApDkk + "DkkRegister/CheckHeinCard", {
      method: "POST", // or 'PUT'
      headers: {
        "Content-Type": "application/json",
        AppCode: "THE",
        TokenCode: token
        // TokenCode:
        //   "fa28f4c1e647efaf86f8f4277125f3213b24599b47b4f2c7d2cb8bd64a93ea1f56511199e6d56eb88bf8ac49f7a6e83b6485e02185650c8f3bbcb0b9a237e3fa"
      },
      body: JSON.stringify(dataDKKCheckCard)
    });
    const data = await response.json();
    console.log("Success", data);
    return data;
  } catch (e) {
    console.log("Error DkkRegister/CheckHeinCard", e);
    return false;
  }
};
export default moduleApi;
